import request from '@/services/request'
import api from '@/services/api'

// 检查文件类型和大小
export function checkedFile(file) {
  const reg = /(.*)\.(jpg|gif|jpeg|tif|png)$/
  if (!reg.test(file.name)) {
    console.log('请上传.jpg .gif .jpeg .tif .png格式文件!')
    return false
  } else if (file.size / 1024 / 1024 > 2) {
    console.log('上传文件大小不能超过2MB!')
    return false
  } else {
    return true
  }
}

// 上传图片
export async function uploadImg(file) {
  if (checkedFile(file.file)) {
    const uploadFileData = new FormData()
    uploadFileData.append('file', file.file)
    const { resultCode, data } = await request(api.common.uploadImage, uploadFileData)
    if (resultCode === '0000') {
      return data
    }
  }
  return null
}
